export const name = "ST_NPOINTS";
export const summary = `An alias of \`ST_NUMPOINTS\`.`;
export const reference = `
## ST_NPOINTS

An alias of \`ST_NUMPOINTS\`.

\`\`\`
ST_NPOINTS(geography_expression)
\`\`\`

### Description

An alias of ST_NUMPOINTS.


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
